import React from "react";
import Link from "next/link";

export const WINNING_METRICS = [
  {
    name: "Game Clock",
    definition: "Quarters/Halves and Time Remaining in each",
    targetPage: ["nfl", "LiveQueryTool"],
  },
  { name: "Actual Points", definition: "Actual Points For", targetPage: ["nfl", "LiveQueryTool"] },
  { name: "Actual Opponent Points", definition: "Opponent Actual Points", targetPage: ["nfl", "LiveQueryTool"] },
  {
    name: "Actual Point Differential",
    definition: "Actual Points minus Actual Opponent Points",
    targetPage: ["nfl", "LiveQueryTool"],
  },
  {
    name: "Actual Total",
    definition: "Sum of Actual Points and Actual Opponent Points",
    targetPage: ["nfl", "LiveQueryTool"],
  },
  {
    name: "Actual Point Differential minus DQ Point Differential",
    definition: "Amount by which the Team's Actual Point Differential Exceeds the Drive Quality Point Differential",
    targetPage: ["LiveQueryTool"],
  },

  {
    name: "Pregame Spread",
    definition: "Closing Consensus Pregame Point Spread",
    targetPage: ["nfl", "LiveQueryTool"],
  },
  { name: "Pregame Total", definition: "Closing Consensus Pregame Total", targetPage: ["nfl", "LiveQueryTool"] },
  { name: "Live Spread", definition: "Live Consensus Point Spread", targetPage: ["nfl", "LiveQueryTool"] },
  { name: "Live Total", definition: "Live Consensus Point Total", targetPage: ["nfl", "LiveQueryTool"] },
  {
    name: "Live Proj Spread",
    definition:
      "Optimized Live Spread Accounting for Score, Time Remaining, Closing Pregame Spread and Drive Quality Score",
    targetPage: ["nfl", "LiveQueryTool"],
  },
  {
    name: "Live Proj Spread v Market Spread Diff",
    definition: "The Difference Between the Live Projected Spread and the Actual Live Spread, at that Time.",
    targetPage: ["nfl", "LiveQueryTool"],
  },
  {
    name: "Live Proj Game Total",
    definition:
      "Optimized Live Total Accounting for Score, Time Remaining, Closing Pregame Total and Drive Quality Combined Score",
    targetPage: ["nfl", "LiveQueryTool"],
  },
  {
    name: "Live Proj Game Total v Market Total Diff",
    definition: "The Difference Between the Live Projected Total and the Actual Live Total, at that Time.",
    targetPage: ["nfl", "LiveQueryTool"],
  },
  {
    name: "Success",
    definition:
      "% of plays where a team gains at least 40% of yards required on 1st down, 60% of yards required on 2nd down, and 100% on 3rd or 4th down",
    targetPage: ["nfl"],
  },
  {
    name: "Explosive",
    definition: "% of plays where a team eithers run for 10 or more yards or passes for 20 or more yards",
    targetPage: ["nfl"],
  },
  {
    name: "Expected Yards per Kickoff (Receiving Team)",
    definition: "Prob(Kickoff Return) * Kickoff Return Average",
    targetPage: ["LiveQueryTool", "TraderDashboard"],
  },
  {
    name: "Expected Yards per Punt (Receiving Team)",
    definition: "Prob(Punt Return) * Punt Return Average",
    targetPage: ["LiveQueryTool", "TraderDashboard"],
  },
  {
    name: "Days Since Teams Last Game",
    definition: "Days since teams last game",
    targetPage: ["LiveQueryTool", "TraderDashboard"],
  },
  {
    name: "Officiating Crew - Offensive Penalties",
    definition: "Prob(Offensive Penalty | Officiating Crew) * Average Offensive Penalty Yards",
    targetPage: ["TraderDashboard"],
  },
  {
    name: "Officiating Crew - Defensive Penalties",
    definition: "Prob(Defensive Penalty | Officiating Crew) * Average Defensive Penalty Yards",
    targetPage: ["TraderDashboard"],
  },
  {
    name: "Team Live SQ PPP",
    definition: "ShotQuality Expected Points Per Possession in the In-Game",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Team Live SQ PPP vs Live PPP %Diff",
    definition:
      "Percentage by which the Team is Underperforming its In-Game Expectations. 10% means the Team is Underperforming & -5% means the Team is Overperforming",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Team Live PPP vs Pre PPP %Diff",
    definition:
      "Percentage by which the Team is Overperforming its Pre-Game Expectations. 10% means the Team is Overperforming & -5% means the Team is Underperforming",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Opp Live PPP",
    definition: "Actual Opponent Points Per Possession in the In-Game",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Opp Live PPP vs Pre PPP %Diff",
    definition:
      "Percentage by which the Opponent is Overperforming its Pre-Game Expectations. 10% means the Opponent is Overperforming & -5% means the Opponent is Underperforming",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Opp Live SQ PPP vs Live PPP %Diff",
    definition:
      "Percentage by which the Opponent is Underperforming its In-Game Expectations. 10% means the Opponent is Underperforming & -5% means the Opponent is Overperforming",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Opp Live SQ PPP",
    definition: "Opponent Expected Points Per Possession in the In-Game",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Max",
    definition:
      "Represents Largest Difference between Live Proj Spread and Live Spread under Current Filtered Criteria ",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Opp SQ Live PPP vs Pre PPP % Diff",
    definition:
      "Percentage by which the Opponent's In-Game Expectations exceed its Pre-Game Expectations. 10% means the Opponent is Underperforming & -5% means the Opponent is Overperforming ",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "SQ Live PPP vs Pre PPP % Diff",
    definition:
      "Percentage by which the Team's In-Game Expectations exceed its Pre-Game Expectations. 10% means the Team is Underperforming & -5% means the Team is Overperforming ",
    targetPage: ["LiveQueryTool"],
  },
  { name: "Opponent SQ Points", definition: "Expected Points Against", targetPage: ["LiveQueryTool"] },
  { name: "SQ Points", definition: "Expected Points For", targetPage: ["LiveQueryTool"] },
  {
    name: "Team Live PPP",
    definition: "Actual Points Per Possession For in the In-Game",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Live Pace vs Pre Pace %Diff",
    definition: "Percentage by which the Game's Actual Pace Exceeds the Pregame Pace",
    targetPage: ["LiveQueryTool"],
  },
  { name: "Live Pace", definition: "The Game's Actual Pace", targetPage: ["LiveQueryTool"] },
  {
    name: "Pregame Pace",
    definition: "Projected Pregame Pace (Average of Both Teams in Previous Games)",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Actual Total minus SQ Total",
    definition: "Amount by which the Actual Total Points Scored by Both Teams Exceeds the total ShotQuality Points.",
    targetPage: ["LiveQueryTool"],
  },
  {
    name: "Actual Point Differential minus SQ Point Differential",
    definition: "Amount by which the Actual Total Points Scored by Both Teams Exceeds the total ShotQuality Points.",
    targetPage: ["LiveQueryTool"],
  },
  { name: "SQ Total", definition: "Sum of SQ Points and Opponent SQ Points", targetPage: ["LiveQueryTool"] },
  { name: "SQ Point Differential", definition: "SQ Points Minus Points", targetPage: ["LiveQueryTool"] },
  { name: "Minimum Time Elapsed", definition: "Minimum Time Elapsed in the Game", targetPage: ["LiveQueryTool"] },

  { name: "Line at Time of Play", definition: "Line at Time of Play", targetPage: ["BestBets"] },
  { name: "Play", definition: "Play", targetPage: ["BestBets"] },
  { name: "Play Line Value", definition: "Play Line Value", targetPage: ["BestBets"] },
  { name: "Points of Value", definition: "Points of Value", targetPage: ["BestBets"] },
  { name: "Selected Book", definition: "Selected Book", targetPage: ["BestBets"] },
  { name: "ShotQuality Projection", definition: "ShotQuality Projection", targetPage: ["BestBets"] },
  {
    name: "Total Score",
    definition:
      "The combined score of both teams in any given basketball game. This is graded against to determine the winner of over & under bets.",
    longDefinition: `In basketball betting, the "total score" typically refers to the combined score of both teams at the end of a game. This concept is central to an over/under bet, which is a common type of wager in sports betting. Here's how it works:
          Setting the Line: Bookmakers set a line for the total score of the game. This line represents the expected combined score of both teams.
          Over/Under Bet: Bettors then wager on whether the actual combined score will be over or under this line.
          Over Bet:
          If you bet on the over, you're betting that the total score will be higher than the bookmaker's line.
          Under Bet:
          Conversely, if you bet on the under, you're betting that the total score will be lower than the line.

          Outcome of the Bet: After the game, the total score is calculated by adding the points scored by each team. If the combined score is higher than the line, the over bets win; if it's lower, the under bets win.

          For example, if the total line for a basketball game is set at 210.5, and the final score is 110-105, the total score would be 215. In this case, those who bet on the over would win, as the actual total (215) is higher than the line (210.5).
          The total score line can vary greatly depending on the teams playing, their scoring histories, and other factors like player injuries or playing conditions. Bettors often analyze these factors to make informed decisions on their over/under bets.
          You can use ShotQualityBets Projections to bet on over and under lines as well as research your plays!
          `,
    targetPage: ["BestBets"],
  },
  {
    name: "bets",
    definition: "bets",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "Cover% ",
    definition:
      "The percentage of time a team covers the spread set by the sportsbooks regardless of whether they are the favorite or the underdog. For example, if the favorite is expected to win by 3 (spread is -3) and they win by 4 the favorite covered. Conversely, if the underdog is expected to lose by 3 (+3) and the ShotQuality Score had them lose by 2 the underdog covered.",
    longDefinition: ``,
    targetPage: ["BettingAnalysis", "BettingRecord"],
  },
  {
    name: "Favorite Win %",
    definition:
      "The winning percentage when the team was the pre-game favorite. A favorite is the the team or player that is expected to win, based on the odds set by bookmakers or sportsbooks. The favorite is typically indicated by a negative point spread or moneyline.",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "Over Win %",
    definition:
      "Percent of times the team went over the closing line set by the sportsbooks. An 'over bet' refers to a type of wager related to the total combined score of a game. Before a game starts, oddsmakers will set a predicted total score for both teams combined. Bettors can then wager on whether the actual combined score will be over or under that predicted total.",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "ShotQuality (SQ) Record",
    definition: "Expected wins and losses for a team, considering the quality of shots taken and allowed.",
    longDefinition: `A team's pythagorean wins using ShotQuality points rather than actual points scored. We use the common exponent for basketball pythagorean win percentage, 14.
SQ Wins = Games * (Expected points)14 / [(Expected points)14 + (Expected points allowed)14]
Similar to net rating, point differential, and similar metrics, ShotQuality Record better reflects a team's ability and predicts future performance better than its current record.
`,
    targetPage: ["BettingAnalysis", "TeamStandings"],
  },
  {
    name: "SQ Cover%",
    definition:
      "The percentage of time a team covers the ShotQuality score differential. For example, if the sportsbooks have a team expected to win by 3 and the ShotQuality Score had them winning by 4 the team covered. Conversely, if the sportsbooks have a team losing by 3 and the ShotQuality Score had them winning by 2 the underdog covered.",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "SQ Favorite Win%",
    definition:
      "The winning percentage when the team was favored by the sportsbooks and won according to the ShotQuality score.",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "SQ Over%",
    definition:
      "The percentage of times the total ShotQuality score of the game went over the projected total from the sportsbooks. ",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "SQ Under%",
    definition:
      "The percentage of times the total ShotQuality score of the game went under the projected total from the sportsbooks. ",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "SQ Underdog Win%",
    definition:
      "The winning percentage when the team was an underdog by the sportsbooks and won according to the ShotQuality score.",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "SQ Win%",
    definition:
      "Percent of games won in the season according to the ShotQuality Score which is based on the team's expected performance. ",
    longDefinition: `A team's pythagorean win percentage using ShotQuality points rather than actual points scored. We use the common exponent for basketball pythagorean win percentage, 14.
SQ Win Percentage = (Expected points)14 / [(Expected points)14 + (Expected points allowed)14]
`,
    targetPage: ["BettingAnalysis", "SQ Win%"],
  },
  {
    name: "Under Win %",
    definition:
      "Percent of times the team went under the closing line set by the sportsbooks.  An 'under bet' refers to a type of wager related to the total combined score of a game. ",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "Underdog Win%",
    definition:
      "The winning percentage when the team was the pre-game underdog. An underdog is the the team or player that is expected to lose, based on the odds set by bookmakers or sportsbooks. The underdog is typically indicated by a negative point spread or moneyline. ",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "Win%",
    definition: "Percent of games won in the season",
    longDefinition: ``,
    targetPage: ["BettingAnalysis"],
  },
  {
    name: "ROI",
    definition:
      "Also Known As: Return on Investment - the raw percent relationship between how much you have risked (invested) and how much you have returned. ",
    longDefinition: `Return on Investment, or ROI, is a performance measure used to evaluate the efficiency or profitability of an investment or compare the efficiency of a number of different investments. ROI tries to directly measure the amount of return on a particular investment, relative to the investment’s cost.
To calculate ROI, the return of an investment is divided by the cost of the investment. The result is expressed as a percentage. The formula for ROI is:
ROI=(Net Profit / Cost of Investment)*100
In sports betting, a positive ROI means that you are making money over a given period, whereas a negative ROI means you are losing money. It's important to note that ROI can be influenced by various factors, such as the odds of the bets placed, the type of bets, and the betting strategy employed.
When evaluating ROI in any context, it's critical to consider the risk associated with the investment, the time period over which the return was generated, and the potential for variability in returns. In betting, as in other forms of investment, a higher ROI is typically associated with higher risk.

Traditionally, the top handicappers in basketball win about 55-57% of their bets. In order to be profitable at a -110 average odds, you need to win 52.38% of your bets. 

Let's do a bit of math:
55% win rate means 55 - 45 over a 100 bet span.
Thats 55u - (45 * 1.1) = 5.5u won every 100 bets at 55%.
Now you have invested 100 * 1.1u because you are playing at -110.
So your ROI is 5.5 / 110 = 5%

57% win rate:
57-43 -> +9.7u every 100 bets
9.7 / 110 = 8.8%

So at 55% win rate playing -110 odd bets, you will win 0.05x every dollar you risk, or $5 for every $100 you risk over time. 

Changing the odds to -120 makes it much tougher because you multiply losses by 1.2u in stead of 1.1u. The break even rate for -120 is 54.55%, -130 is 56.52% and so on. The steeper the odds, the more you must win to profit. 

Long term, any positive ROI means you are winning. In terms of understanding what is good, or great, a 5% ROI is great. A 3% ROI is good. and anything above 8% ROI on a reliable scale is difficult to find and should be treasured.

`,
    targetPage: ["ModelSandbox", "Results", "BettingRecord"],
  },
  {
    name: "Wins",
    definition: "Wins represent a tally of successful ShotQualityBets predictions against betting spreads and lines.",
    longDefinition: `In the context of ShotQualityBets, a "Win" refers to the successful prediction of one of our models, either against the spread (ATS) or on an over or under (OU) line. Each 

"Win" corresponds to a bet won, showcasing the accuracy and effectiveness of our model. It's a straightforward metric that offers users a quick glimpse into the model's performance.
`,
    targetPage: ["ModelSandbox", "Results", "Trends"],
  },
  {
    name: "Side With Value",
    definition:
      "This indicates which side of a betting line the ShotQualityBets model is showing value on. Combine this with Points of Value to get the complete picture!",
    longDefinition: `There are two sides to the betting lines the ShotQualityBets' model plays. 

For spread bets: it is one team or another against the number the oddsmakers have set. 
For total bets: it is the over or the under on the line for total points the oddsmakers have set.
When using the Daily Projections tool, this column indicates which side the model has value on. Combine it with Points of Value to complete the process of understanding our projections and 
`,
    targetPage: ["Results"],
  },
  {
    name: "Best Bet (Props)",
    definition: "Best bet is your best player props pick.",
    longDefinition: ``,
    targetPage: ["PlayerProps"],
  },
  {
    name: "Points per Shot (PPS)",
    definition: "Points per field goal attempt.",
    longDefinition: `Points per true shooting attempt, or PTS / (FGA + 0.44 * FTA). This measures overall scoring efficiency, considering the additional value of a made three-point shot, and free throws.`,
    targetPage: ["Scores", "ScoreCenter"],
  },
  {
    name: "SQ PPS",
    definition:
      "Expected Points Per Shot. Incorporates up to 90 variables, including shot type, shooter ability, defender location, and defender height.",
    longDefinition: ``,
    targetPage: ["Scores", "ScoreCenter"],
  },
  {
    name: "SQ Result",
    definition:
      "SQ Result is the expected average final score if the two teams played again with the same shot selection.",
    longDefinition: `For each field goal attempt and free throw attempt in the game, we calculate ShotQuality Points, which consider player ability, shot characteristics, and defensive information to calculate the probability that a shot is made. An open three might have a 50 percent make probability, or 1.50 expected points, while a dunk could be 99 percent, or 1.98 expected points.
The SQ Result for a team its ShotQuality Points for the entire game, which is the average number of points we expect it to score on its shot attempts.`,
    targetPage: ["Scores"],
  },
  {
    name: "Adjusted ShotQuality (adj SQ)",
    definition:
      "Adjusted ShotQuality (adj SQ) evaluates a team's shooting efficacy (adjOFF SQ) and defensive prowess (adjDEF SQ) adjusted for strength of schedule (teams facing tougher opponents see ratings adjust favorably, while those against weaker foes show a decline).",
    longDefinition: `What is Adjusted ShotQuality (adj SQ)?
At its core, adj SQ is all about leveling the playing field. It gives you a richer, more nuanced look at ShotQuality by adjusting for the 'strength of schedule.' In simple terms, it considers who you're playing against. This is a two-sided coin:
Adjusted Offensive Shot Quality (adjOFF SQ): This measures how well a team is shooting, but gives you a more accurate picture by considering the quality of the defenses they've played against. If a team has faced mostly weak defenses, their adjOFF SQ will be lower than their raw Offensive Shot Quality. It keeps things real, folks!
Adjusted Defensive Shot Quality (adjDEF SQ): This is the flip side—how well a team is defending, again adjusted for the quality of offenses they've faced. Playing against top-notch offenses? Your adjDEF SQ will be higher, recognizing the tougher competition.

`,
    targetPage: ["TeamStandings"],
  },
  {
    name: "Constant",
    definition: "Constant value to add to the projection.",
    longDefinition: ``,
    targetPage: ["TraderDashboard"],
  },
  {
    name: "Live Actual Points per Possession",
    definition: "The team's offensive rating (points per 100 possessions) in the game so far.",
    longDefinition: ``,
    targetPage: [""],
  },
  {
    name: "Live ShotQuality Points per Possession",
    definition: "The team's ShotQuality expected offensive rating (points per 100 possessions).",
    longDefinition: `his is a luck-adjusted metric that measures the team's average points scored on an identical sample of shots (incorporating shot context, player ability, and opponent). This is valuable because it reflects in-game information, namely the quality of shots, and is more predictive of the remainder of the game. Once we learn how the game is played after several minutes, team shot selection stays relatively consistent (i.e. lots of open threes, few shots in the paint), but shooting result can vary (i.e. three-point shooting luck). ShotQuality Points per Possession isolates the “sticky” components of team performance to create a more accurate forecast.`,
    targetPage: ["TraderDashboard"],
  },
  {
    name: "Live Spread/OU",
    definition:
      "Live OU is the consensus market prices being offered live consisting of a blended average of: DraftKings, FanDuel, Kambi, Bet365, and Pinnacle",
    longDefinition: ``,
    targetPage: [""],
  },
  {
    name: "Pregame Points per Possession",
    definition:
      "The team's offensive rating (points per 100 possessions) as predicted by the pregame spread, pregame total, and the average pace of the two teams (Pregame Pace).",
    longDefinition: ``,
    targetPage: ["TraderDashboard"],
  },
  {
    name: "Projected Spread/OU",
    definition:
      "Blended average incorporating the weights used on pregame expected metrics and live SQ metrics located in the 'Weights' tab within Trader Dashboard",
    longDefinition: ``,
    targetPage: ["TraderDashboard"],
  },
  {
    name: "Regression Points per Possession",
    definition:
      "Strong evidence exists that teams play slightly worse as score margin increases, and teams play slightly better as score margin decreases. A team leading by 10 points will play slightly worse than the same team leading by 20 points. Regression Points per Possession accounts for this, allowing us to forecast counterintuitive and non-competitive results that can occur in a game.",
    longDefinition: `Strong evidence exists that teams play slightly worse as score margin increases, and teams play slightly better as score margin decreases. A team leading by 10 points will play slightly worse than the same team leading by 20 points. Regression Points per Possession accounts for this, allowing us to forecast counterintuitive and non-competitive results that can occur in a game. For example, a game with a 40-point halftime margin will have a non-competitive second half, likely with many bench players and reserves playing the majority of the game. This should be analyzes with care since it occurs in a different environment than the first half of the game, rendering those first half statistics less informative. Regression Points per Possession accounts for this phenomenon.`,
    targetPage: ["TraderDashboard"],
  },
  {
    name: "SQ Optimized Model",
    definition: `For each four-minute period of the game, we fit a linear model to the six pace-efficiency combinations:
1. Live pace and pregame PPP
2. Live pace and live PPP
3. Live pace and live SQ PPP
4. Pregame pace and pregame PPP
5. Pregame pace and live PPP
6. Pregame pace and live SQ PPP
`,
    longDefinition: ``,
    targetPage: ["TraderDashboard"],
  },
  {
    name: "",
    definition: "",
    longDefinition: ``,
    targetPage: [""],
  },
  {
    name: "",
    definition: "",
    longDefinition: ``,
    targetPage: [""],
  },
  {
    name: "",
    definition: "",
    longDefinition: ``,
    targetPage: [""],
  },
];

function WinningMetrics({ targetSite = "ShotQualityBets", targetPage = "Glossary" }) {
  return (
    <>
      <div
        className="p-4 pb-5 pt-5 winning-metrics"
        style={{
          backgroundColor: "#f3f4f6",
          backgroundColor: "#fff",
          borderTop: "1px solid #e5e5e5",
        }}
      >
        <div className="row">
          <div className="col-12">
            <h1 className=" mb-4 color-orange text-uppercase fw-9">Winning Metrics</h1>
            <p>See How we do it.</p>
          </div>
          {WINNING_METRICS.map((metric, index) =>
            metric.targetPage.includes(targetPage) ? (
              <div className="col-12 col-md-4 p-4" key={index}>
                <Link className="is-link" href={`/glossary/` + encodeURIComponent(metric.name)} target="_blank">
                  <div className="p-4 border-radius-10 box-shadow-1 h-100 glow-border">
                    <div>
                      <h3 className="color-orange fw-9">{metric.name}</h3>
                      {/* <h5 className="is-link">{documentToReactComponents(metric.definition)}</h5> */}
                      <h5 className="is-link" style={{ whiteSpace: "pre-line" }}>
                        {metric.definition}
                      </h5>
                    </div>
                  </div>
                </Link>
              </div>
            ) : null
          )}
        </div>
      </div>
    </>
  );
}

export default WinningMetrics;
